import { __decorate } from "tslib";
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { computed } from 'mobx';
import ViewComponent from '../core/ViewComponent';
import localeContext from '../locale-context/LocaleContext';
export default class DataSetComponent extends ViewComponent {
    get dataSet() {
        return this.observableProps.dataSet;
    }
    get lang() {
        const { lang } = this.observableProps;
        if (lang) {
            return lang;
        }
        const { dataSet } = this;
        if (dataSet && dataSet.lang) {
            return dataSet.lang;
        }
        return localeContext.locale.lang;
    }
    getObservableProps(props, context) {
        return {
            ...super.getObservableProps(props, context),
            dataSet: props.dataSet,
        };
    }
    getOtherProps() {
        return omit(super.getOtherProps(), ['dataSet']);
    }
}
DataSetComponent.propTypes = {
    dataSet: PropTypes.object,
    ...ViewComponent.propTypes,
};
__decorate([
    computed
], DataSetComponent.prototype, "dataSet", null);
__decorate([
    computed
], DataSetComponent.prototype, "lang", null);
